<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">

    <div [ngClass]="{'shadow dark:shadow-none z-10': showScrollToTop}"
        class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between p-4 sm:pt-4 sm:px-6 bg-default dark:bg-transparent">

        <div class="w-full flex  justify-between items-center">
            <div>
                <div class="text-2xl font-extrabold tracking-tight truncate">Copilot Configuration</div>
                <div class="text-secondary truncate">Enable or disable assistants and agents</div>
            </div>

            <div class="flex gap-1 justify-end  w-full">
                <button mat-flat-button color="primary" (click)="save()">Save Changes</button>
            </div>
        </div>
    </div>
    <div class="flex flex-col h-full bg-white dark:bg-gray-900 no-select">
        <mat-drawer-container class="h-full lol-ac-left-drawer">
            <!-- Drawer (Side) -->
            <mat-drawer class=" dark:bg-gray-900" [autoFocus]="false" [mode]="drawerMode" [opened]="drawerOpened"
                #drawer>
                <!-- Header and Toggle Button  -->
                <div class="flex w-full shadow dark:shadow-none dark:border-b">
                    <div class="flex w-full items-center justify-between space-x-2 m-6 mr-6 sm:my-4">
                        <div class="text-xl font-bold tracking-tight leading-none">
                            Configurations
                        </div>
                        <button *ngIf="drawer.opened" mat-icon-button (click)="drawer.toggle()">
                            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                        </button>
                    </div>
                </div>

                <!-- Panel links -->
                <div class="flex flex-auto panel-wrapper mt-1">
                    <div class="flex flex-col divide-y h-full max-h-5xl bg-transparent">
                        <ng-container *ngFor="let panel of focusList; trackBy: trackByFn">
                            <div class="flex px-3 py-5 cursor-pointer select-none"
                                [ngClass]="{'hover:bg-gray-100 dark:hover:bg-hover bg-white dark:bg-slate-800 dark:hover:text-blue-200 transition-all': !selectedPanel || selectedPanel !== panel.id,
                                'bg-primary-50 dark:bg-hover transition-all': selectedPanel && selectedPanel === panel.id}" (click)="goToPanel(panel.id)">
                                <mat-icon
                                    [ngClass]="{'text-hint transition-all': !selectedPanel || selectedPanel !== panel.id,
                                    'text-primary transition-all dark:text-primary-300': selectedPanel && selectedPanel === panel.id}"
                                    [svgIcon]="panel.icon"></mat-icon>
                                <div class="ml-3">
                                    <div class="font-medium leading-6 select-none"
                                        [ngClass]="{'text-primary transition-all dark:text-primary-300' : selectedPanel && selectedPanel === panel.id}">
                                        {{panel.title}}
                                    </div>
                                    <div class="mt-0.5 text-secondary text-sm select-none"
                                        [ngClass]="{'text-primary transition-all dark:text-primary-300': selectedPanel && selectedPanel === panel.id}">
                                        {{panel.description}}
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </mat-drawer>
            <!-- Drawer (Main Content) -->
            <mat-drawer-content class="flex flex-row">

                <div class="flex flex-col w-full px-6">

                    <!-- Load settings panel -->
                    <div class="lol-settings-ac-right flex w-full flex-col space-y-4">
                        @if(showScrollToTop){
                        <button class="scroll-to-top" (click)="scrollToTop()">
                            ↑ Scroll to top
                        </button>
                        }

                        <ng-container [ngSwitch]="selectedPanel">
                            <!-- Assistants -->
                            <ng-container *ngSwitchCase="'assistants'">
                                <fuse-card class="flex w-full no-select">
                                    <div class="flex flex-col w-full ps-2">
                                        <div class="flex gap-2 items-center">
                                            <button *ngIf="!drawer.opened" mat-icon-button (click)="drawer.toggle()">
                                                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                                            </button>
                                            <h3 class="text-xl font-semibold p-4 ">
                                                Assistants Controls
                                            </h3>
                                        </div>


                                        <div class="w-full">

                                            <fuse-alert [type]="'info'" class="mx-2" [appearance]="'outline'">
                                                <span fuseAlertMessage>Enable or Disable specific assistants within your
                                                    account </span>
                                            </fuse-alert>

                                            <div class="overflow-hidden">
                                                <mat-table [dataSource]="settings.assistants"
                                                    class="mat-elevation-z8 w-full text-left table-auto border-collapse">


                                                    <!-- Description Column -->
                                                    <ng-container matColumnDef="name">
                                                        <mat-header-cell *matHeaderCellDef
                                                            class="py-2 px-4 flex-auto text-left table-desc">
                                                            Name </mat-header-cell>
                                                        <mat-cell *matCellDef="let feature"
                                                            class="py-2 px-4 flex-auto text-left table-desc">
                                                            <div (click)="feature.value = !feature.value"
                                                                class="cursor-pointer">
                                                                {{ feature.name }}
                                                            </div>
                                                        </mat-cell>
                                                    </ng-container>

                                                    <!-- Toggle Column -->
                                                    <ng-container matColumnDef="enabled">
                                                        <mat-header-cell *matHeaderCellDef
                                                            class="py-2 px-4 max-w-[100px] text-left"> On / Off
                                                        </mat-header-cell>
                                                        <mat-cell *matCellDef="let feature; let i = index"
                                                            class="py-2 px-4 max-w-[100px] text-left">
                                                            <mat-slide-toggle color="primary"
                                                                [(ngModel)]="feature.enabled"></mat-slide-toggle>
                                                        </mat-cell>
                                                    </ng-container>

                                                    <!-- Define header and row -->
                                                    <mat-header-row *matHeaderRowDef="featureColumns"></mat-header-row>
                                                    <mat-row *matRowDef="let row; columns: featureColumns;"
                                                        class="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                                    </mat-row>
                                                </mat-table>
                                            </div>

                                        </div>
                                    </div>
                                </fuse-card>
                            </ng-container>


                            <!-- Agents -->
                            <ng-container *ngSwitchCase="'agents'">
                                <fuse-card class="flex w-full no-select">
                                    <div class="flex flex-col w-full ps-2">
                                        <div class="flex gap-2 items-center">
                                            <button *ngIf="!drawer.opened" mat-icon-button (click)="drawer.toggle()">
                                                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                                            </button>
                                            <h3 class="text-xl font-semibold p-4 ">
                                                Agents Controls
                                            </h3>
                                        </div>

                                        <div class="w-full">
                                            <fuse-alert [type]="'info'" class="mx-2" [appearance]="'outline'">
                                                <span fuseAlertMessage>Enable or Disable specific Agents within your
                                                    account</span>
                                            </fuse-alert>

                                            <div class="overflow-hidden">
                                                <mat-table [dataSource]="settings.agents"
                                                    class="mat-elevation-z8 w-full text-left table-auto border-collapse">

                                                    <!-- Description Column -->
                                                    <ng-container matColumnDef="name">
                                                        <mat-header-cell *matHeaderCellDef
                                                            class="py-2 px-4 flex-auto text-left table-desc">
                                                            Name </mat-header-cell>
                                                        <mat-cell *matCellDef="let feature"
                                                            class="py-2 px-4 flex-auto text-left table-desc">
                                                            <div (click)="feature.value = !feature.value"
                                                                class="cursor-pointer">
                                                                {{ feature.name }}
                                                            </div>
                                                        </mat-cell>
                                                    </ng-container>

                                                    <!-- Toggle Column -->
                                                    <ng-container matColumnDef="enabled">
                                                        <mat-header-cell *matHeaderCellDef
                                                            class="py-2 px-4 max-w-[100px] text-left"> On / Off
                                                        </mat-header-cell>
                                                        <mat-cell *matCellDef="let feature; let i = index"
                                                            class="py-2 px-4 max-w-[100px] text-left">
                                                            <mat-slide-toggle color="primary"
                                                                [(ngModel)]="feature.enabled"></mat-slide-toggle>
                                                        </mat-cell>
                                                    </ng-container>

                                                    <!-- Define header and row -->
                                                    <mat-header-row *matHeaderRowDef="featureColumns"></mat-header-row>
                                                    <mat-row *matRowDef="let row; columns: featureColumns;"
                                                        class="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                                    </mat-row>
                                                </mat-table>
                                            </div>

                                        </div>
                                    </div>
                                </fuse-card>
                            </ng-container>

                        </ng-container>
                    </div>
                </div>

            </mat-drawer-content>
        </mat-drawer-container>
    </div>
</div>
